<div class="container-custom">
    <div class="row align-items-center justify-content-center">
        <form #form="ngForm" (ngSubmit)="onSubmit(form)" autocomplete="off" novalidate>
            <div class="card dropshadow-custom" style="width: 50rem;">
                <div class="card-header">Crypto</div>
                <div class="card-body">
                    
                        <h4 class="card-title mb-4 mt-1">Text to crypt:</h4>
                        <hr>
                        <div class="form-group">
                            <input type="text" name="text" class="form-control w-100" id="text" ngModel required>
                        </div>

                        
                        <div class="spacer-custom-100"></div>
                

                    <div *ngIf="respReq">
                        <div class="spacer-custom-100"></div>
                        <div class="spacer-line-custom"></div>
                        <div class="text-center">
                            <div style="width: 100%; height: 1rem;"></div>
                            <div *ngIf="!error" class="alert alert-custom alert-green-custom text-center fade show w-100" style="margin: auto;" role="alert">
                                <h2>{{resCode}}</h2>
                            </div>
                            <div *ngIf="error" class="alert alert-custom alert-red-custom text-center fade show" role="alert">
                                <h6>{{resError}}</h6>
                            </div>
                        </div>
                    </div>

                    <div class="spacer-custom-100"></div>
                    <div class="spacer-line-custom"></div>
                    <div class="spacer-custom-100"></div>
                    <div class="spacer-custom-100"></div>
                    <div class="spacer-custom-100"></div>


                    
                        <div class="text-center">
                            <button class="btn btn-custom" style="min-width: 100px" type="submit" [disabled]="form.invalid">Crypt</button>
                            &nbsp;
                            <button class="btn btn-outline-custom" type="button" (click)="resetForm(form)">Cancel</button>
                        </div>
                    


                 </div>
             </div>
</form>
    </div>

 </div>
